export function formatINROrBlank(value) {
  return Number(value) ? formatINR(value) : "";
}

export function formatINR(value) {
  const amount = Number(value);
  const safe = Number.isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(safe);
}

export function todayInput() {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

export function monthStartInput() {
  return `${todayInput().slice(0, 8)}01`;
}

export function formatDate(iso) {
  if (!iso) return "";
  const [year, month, day] = String(iso).slice(0, 10).split("-");
  if (!day) return iso;
  return `${day}-${month}-${year}`;
}

export function ledgerIdOf(row) {
  if (!row) return "";
  const raw = row.id || row._id;
  if (raw && typeof raw === "object") return raw.$oid || "";
  return String(raw || "");
}

export function getAccountUser() {
  try {
    const raw = JSON.parse(localStorage.getItem("userData") || "{}");
    const data = raw.data || {};
    const roles = (data.roles || []).map((role) => role.roleId || role);
    return {
      name: data.firstName || data.userId || "",
      roles,
      token: raw.token || "",
    };
  } catch (err) {
    return { name: "", roles: [], token: "" };
  }
}

export function can(roles, allowed) {
  if (!roles) return false;
  if (roles.includes("ADMIN")) return true;
  return allowed.some((role) => roles.includes(role));
}

export function isCustomerOnly(roles) {
  return roles.includes("CUSTOMER") && !roles.some((role) => ["ADMIN", "ACCOUNTANT", "SALESMAN"].includes(role));
}
